import React from "react";
import { removeStyle, styled } from "../utils/dom";

export default class GlobalStyleProvider extends React.Component<{
  styles: string;
}> {
  static defaultProps = {
    styles: "",
  };

  styleId: string;

  componentDidMount() {
    this.styleId = styled()`
      ${this.props.styles}
    `;
  }

  componentWillUnmount() {
    removeStyle(this.styleId);
  }

  render() {
    return null;
  }
}
